// Loads videos instantly from static JSON, then silently checks for new ones in background

const API_KEY    = 'AIzaSyAzIjifpf2cXjEKqo4rK6ximZQSbR8jjvY';
const CHANNEL_ID = 'UCykPglAMLIOQhLeeiUWylMA';
const YT_API     = 'https://www.googleapis.com/youtube/v3';
const NEW_CACHE_KEY = 'yt_new_videos';
const NEW_CACHE_TTL = 60 * 60 * 1000; // re-check every 1 hour

let memCache = null;

export async function fetchChannelVideos() {
  if (memCache) return memCache;

  // Step 1 — load static JSON instantly
  const res    = await fetch('/videos.json');
  const static_videos = await res.json();

  // Step 2 — merge any new videos found in sessionStorage from a previous background check
  const merged = mergeNew(static_videos);
  memCache = merged;

  // Step 3 — trigger background check for new videos (non-blocking)
  checkForNewVideos(static_videos).then(updated => {
    if (updated) memCache = updated;
  }).catch(() => {});

  return memCache;
}

// Merge new videos (from background check) into the static list
function mergeNew(base) {
  try {
    const raw = sessionStorage.getItem(NEW_CACHE_KEY);
    if (!raw) return base;
    const { videos: newVids } = JSON.parse(raw);
    if (!newVids?.length) return base;
    const existingIds = new Set(base.map(v => v.id));
    const fresh = newVids.filter(v => !existingIds.has(v.id));
    return fresh.length > 0 ? [...fresh, ...base] : base;
  } catch {
    return base;
  }
}

// Background: fetch only the latest 50 videos from YouTube API
async function checkForNewVideos(base) {
  try {
    // Skip if checked recently
    const raw = sessionStorage.getItem(NEW_CACHE_KEY);
    if (raw) {
      const { ts } = JSON.parse(raw);
      if (Date.now() - ts < NEW_CACHE_TTL) return null;
    }

    // Get uploads playlist ID
    const chanRes  = await fetch(`${YT_API}/channels?part=contentDetails&id=${CHANNEL_ID}&key=${API_KEY}`);
    const chanData = await chanRes.json();
    const uploadsId = chanData.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;
    if (!uploadsId) return null;

    // Fetch only the latest 50 videos (1 API call)
    const plRes  = await fetch(`${YT_API}/playlistItems?part=snippet&playlistId=${uploadsId}&maxResults=50&key=${API_KEY}`);
    const plData = await plRes.json();
    if (plData.error) return null;

    const latest = (plData.items || []).map(item => {
      const s   = item.snippet;
      const vid = s.resourceId?.videoId;
      if (!vid) return null;
      return {
        id:           vid,
        ytId:         vid,
        title:        s.title,
        description:  (s.description || '').slice(0, 300),
        thumbnail:    s.thumbnails?.maxres?.url || s.thumbnails?.high?.url || `https://img.youtube.com/vi/${vid}/hqdefault.jpg`,
        publishedAt:  s.publishedAt,
        channelTitle: s.channelTitle || 'Shri FM',
        showTitle:    s.channelTitle || 'Shri FM',
      };
    }).filter(Boolean);

    // Save to sessionStorage
    sessionStorage.setItem(NEW_CACHE_KEY, JSON.stringify({ ts: Date.now(), videos: latest }));

    // Find truly new ones not in static JSON
    const existingIds = new Set(base.map(v => v.id));
    const fresh = latest.filter(v => !existingIds.has(v.id));

    if (fresh.length > 0) {
      console.log(`✅ ${fresh.length} new video(s) found and added`);
      return [...fresh, ...base];
    }

    return null;
  } catch {
    return null;
  }
}
